'use strict';

angular.module('jericho')
.run(function (Basket) {}) // jshint ignore:line
.factory('Basket', BasketModel);

function BasketModel (DS)
{
    return DS.defineResource({
        basePath: '/api/',
        name: 'Kitbag',
        endpoint: 'baskets',
        upsert: true,
        relations: {
            hasOne: {
                File: {
                    localField: 'file',
                    localKey: 'file_id'
                }
            }
        }
    });
}
